// Programmatic trigger for the bug reporter so UI elements (e.g. a "Submit a bug"
// button) can open it, in addition to the Ctrl+Shift+B keyboard shortcut.

export const BUG_REPORTER_OPEN_EVENT = 'clareefai:open-bug-reporter';

// Mirrors the env gate in BugReporterProvider so callers can hide their trigger
// UI when the reporter is disabled.
export const isBugReporterEnabled =
  import.meta.env.VITE_BUG_REPORTER_ENABLED === 'true';

export function openBugReporter() {
  window.dispatchEvent(new CustomEvent(BUG_REPORTER_OPEN_EVENT));
}
